import { useState } from "react"
import { flushSync } from "react-dom"
import { usePageContext } from "vike-react/usePageContext"
import ContactSalesDialog from "../ContactSalesDialog"
import CustomerSupportPanel from "../CustomerSupportPanel"
import FooterDesktop from "./FooterDesktop"
import FooterMobile from "./FooterMobile"

function Footer() {
  const pageContext = usePageContext()
  const currentPath = pageContext?.currentPath || pageContext?.urlPathname || (typeof window !== 'undefined' ? window.location.pathname : '/')
  const [salesOpen, setSalesOpen] = useState(false)

  const shouldHide = currentPath?.startsWith('/admin') ||
                    currentPath?.startsWith('/c/') ||
                    currentPath?.startsWith('/s/') ||
                    currentPath?.startsWith('/r/') ||
                    (typeof window !== 'undefined' &&
                      (window.location.pathname.startsWith('/admin') ||
                       window.location.pathname.startsWith('/c/') ||
                       window.location.pathname.startsWith('/s/') ||
                       window.location.pathname.startsWith('/r/')))

  if (shouldHide) return null

  const closeSales = () => {
    document.documentElement.style.scrollBehavior = "auto"
    flushSync(() => setSalesOpen(false))
    document.documentElement.style.scrollBehavior = ""
  }

  return (
    <>
      <div className="hidden lg:block">
        <FooterDesktop onOpenContactSales={() => setSalesOpen(true)} />
      </div>
      <div className="block lg:hidden">
        <FooterMobile onOpenContactSales={() => setSalesOpen(true)} />
      </div>

      {/* Contact Sales (controlled) + Customer Support (PubSub: open:customer-support) */}
      <ContactSalesDialog isOpen={salesOpen} onClose={closeSales} />
      <CustomerSupportPanel />
    </>
  )
}

// AldooComponent definition for auto-discovery
export const AldooComponent = {
  id: "Footer",
  component: Footer,
  description: "Footer with logo, navigation groups (Product/Company/Support), contact-sales + customer-support forms, copyright and powered-by. Auto-hides on admin routes.",
  input: {},
}

export default Footer
